import { isLocationAvailableWithAffirm } from '../../../api/Utils/affirmUtils';
import { pushEvent } from '../../../utilities/dataLayerUtils';
import * as COPY from './copy';

export const paymentMethodsTypes = {
  CREDIT_CARD: 'credit-card',
  CREDIT_CARD_ENABLED: 'creditEnabled',
  AFFIRM: 'affirm',
  AFFIRM_ENABLED: 'affirmEnabled',
  PAYPAL: 'paypal',
  PAYPAL_ENABLED: 'payPalEnabled',
  APPLE_PAY: 'applePayEnabled',
  GOOGLE_PAY: 'googlePayEnabled',
  FREE_VOUCHER: 'freeVoucher'
};

const getPaymentMethodLabel = paymentMethodType => {
  switch (paymentMethodType) {
    case paymentMethodsTypes.CREDIT_CARD:
      return COPY.creditCard;
    case paymentMethodsTypes.APPLE_PAY:
      return COPY.applePay;
    case paymentMethodsTypes.PAYPAL:
      return COPY.paypal;
    case paymentMethodsTypes.AFFIRM:
      return COPY.affirmLabel;
    case paymentMethodsTypes.GOOGLE_PAY:
      return COPY.googlePay;
    default:
      return '';
  }
};

export const pushSelectedPaymentMethodEvent = paymentMethodType => {
  pushEvent({
    event: 'custom_click',
    click_category: 'payment_method_selected',
    click_type: getPaymentMethodLabel(paymentMethodType)
  });
};

export const getShouldDisplayGooglePay = (paymentMethodsAllowed, isFreeVoucher) =>
  Boolean(paymentMethodsAllowed?.[paymentMethodsTypes.GOOGLE_PAY] && !isFreeVoucher);

export const getShouldDisplayCreditCard = (paymentMethodsAllowed, isFreeVoucher) =>
  paymentMethodsAllowed?.[paymentMethodsTypes.CREDIT_CARD_ENABLED] && !isFreeVoucher;

export const getShouldDisplayAffirm = (
  paymentMethodsAllowed,
  resortLocation,
  isFreeVoucher,
  isSuiteBookingFlow = false,
  isAffirmAvailable = false
) => {
  return Boolean(
    paymentMethodsAllowed?.[paymentMethodsTypes.AFFIRM_ENABLED] &&
      isLocationAvailableWithAffirm(resortLocation) &&
      ((!isSuiteBookingFlow && isAffirmAvailable) || isSuiteBookingFlow) &&
      !isFreeVoucher
  );
};
export const getShouldDisplayPaypal = (paymentMethodsAllowed, isFreeVoucher) =>
  Boolean(paymentMethodsAllowed?.[paymentMethodsTypes.PAYPAL_ENABLED] && !isFreeVoucher);

export const getShouldDisplayApplePay = (paymentMethodsAllowed, isFreeVoucher) =>
  Boolean(
    paymentMethodsAllowed?.[paymentMethodsTypes.APPLE_PAY] && window.ApplePaySession !== undefined && !isFreeVoucher
  );

export const getHasPointsOffers = (pointsBalance, activeOffers) =>
  (pointsBalance && pointsBalance !== 0) || activeOffers?.length !== 0 ? true : false;

export const getTotalToCharge = (dueTodayAmount, summaryTotal, isDaypassBookingFlow) => {
  const value = isDaypassBookingFlow ? summaryTotal : dueTodayAmount;

  return value && value > 0 ? parseFloat(value).toFixed(2) : '0.00';
};

export const getValidationErrors = errorObj => {
  return [
    ...Object.keys(errorObj.validationErrors).reduce((accumulator, validationError) => {
      const messages = errorObj.validationErrors[validationError];
      return [...accumulator, ...messages];
    }, []),
    ...(errorObj.details ? errorObj.detail : []),
    ...(errorObj?.err?.response?.data?.detail ? [errorObj.err.response.data.detail] : [])
  ];
};

export const getSelectedPaymentMethodExpressCheckout = (availablePaymentMethods, isGooglePaymentActive) => {
  if (window.ApplePaySession && availablePaymentMethods.includes(paymentMethodsTypes.APPLE_PAY))
    return paymentMethodsTypes.APPLE_PAY;
  if (isGooglePaymentActive && availablePaymentMethods.includes(paymentMethodsTypes.GOOGLE_PAY))
    return paymentMethodsTypes.GOOGLE_PAY;
  return paymentMethodsTypes.CREDIT_CARD;
};

export const getIsFreeVoucher = (isDaypassBookingFlow, dayPasses) => {
  return isDaypassBookingFlow && dayPasses.selectedRate === 0;
};
